<template>
  <div class="row mx-0 mb-5">
    <div
      class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 mb-5 mb-lg-0 mx-auto"
    >
      <form>
        <div class="change-class d-flex align-items-center mb-3 mb-md-4">
          <div class="profile-img">
            <img
              v-if="userDetails.ProfileURl != 'https://img.gogocinema.com/'"
              :src="userDetails.ProfileURl"
              class
            />
            <img v-else src="@/assets/img/user.png" class />
            <label for="editProfilePicture" class="edit-profile-link mb-0 ">
              <!-- <input type="file"  id="file-upload"> -->
              <img
                src="@/assets/img/svg/icon-edit-black.svg"
                width="15px"
                height="15px"
              />
            </label>
          </div>
          <input
            type="file"
            v-on:change="onFileChanged($event)"
            id="editProfilePicture"
            class="d-none"
          />
        </div>

        <div class="pr-lg-4 pr-xl-0">
          <div class="mb-3 mb-lg-4 d-flex align-items-center">
            <input
              v-validate="'required'"
              v-model="userDetails.UserName"
              type="text"
              id="username1"
              name="username1"
              placeholder="Enter User name"
              :disabled="isUserNameDisabled"
            />
            <label for="username1" class="mb-0 ml-2 text-nowrap change-class">
              <img
                src="@/assets/img/svg/icon-edit-black.svg"
                width="20px"
                class="img-fluid"
                v-on:click="isUserNameDisabled = !isUserNameDisabled"
              />
            </label>
          </div>

          <div class="mb-3 mb-md-4" style="padding-right: 28px;">
            <input
              v-validate="'required|email'"
              v-model="userDetails.Email"
              type="email"
              id="editEmail"
              name="editEmail"
              placeholder="Enter Email Id"
              :disabled="isEmailDisabled"
            />
            <!-- <label for="editEmail" class="mb-0 ml-2 d-md-block d-lg-inline text-nowrap"><span
            v-on:click="isEmailDisabled = !isEmailDisabled" class="text-primary">Change</span> your Email ID</label>-->
          </div>

          <div class="d-flex mb-4 align-items-center">
            <div class="w-100 d-flex mob-mx-w">
              <div class="country-code-drop drop-mob-max">
                <b-dropdown
                  class="pc-input form-control aaaa"
                  :text="userDetails.country_mob_code || 'Code'"
                  :disabled="isPhoneNumberDisabled"
                  variant="default"
                  slot="append"
                >
                  <div class="px-2 pb-2">
                    <input
                      type="search"
                      placeholder="Search Code"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchCode($event.target.value)"
                      v-on:keydown="onSearchCode($event.target.value)"
                      v-on:search="onSearchCode($event.target.value)"
                      v-model="searchCode"
                    />
                  </div>
                  <b-dropdown-item
                    class
                    v-on:click="onChangeCountryCode(country)"
                    v-for="(country, countryIndex) in CountryCodeList"
                    :key="countryIndex"
                    >{{ country.country_mob_code }}
                    {{ country.country_name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>

              <input
                v-validate="'required'"
                class="ml-2"
                v-model="userDetails.MobileNo"
                type="number"
                :min="0"
                id="editNumber"
                name="editNumber"
                placeholder="Enter Mobile Number"
                :disabled="isPhoneNumberDisabled"
              />
            </div>
            <label for="editNumber" class="mb-0 ml-2 text-nowrap change-class">
              <img
                src="@/assets/img/svg/icon-edit-black.svg"
                width="20px"
                class="img-fluid"
                v-on:click="isPhoneNumberDisabled = !isPhoneNumberDisabled"
              />
            </label>
          </div>

          <!-- <div class="mb-2 mb-md-3">
            <input v-validate="'required'" v-model="countryDetails.CountryName" type="text" id="editNumber"
              placeholder="Select Your Country">
            <label for="editNumber" class="mb-0 ml-2 text-nowrap change-class">
              <img src="@/assets/img/svg/icon-edit-black.svg" width="20px" class="img-fluid"
             v-on:click="onChangeCountry()"></label>
          </div>-->

          <!-- COUNTRY SELECTION MODAL -->
          <b-modal
            ref="countryModalRef"
            id="countryModal"
            hide-header
            hide-footer
          >
            <div class="modal-title">Choose your country</div>

            <div class="p-3">
              <div class="row">
                <div
                  class="text-center col"
                  v-for="(country, index) in countries"
                  :index="index"
                  :key="index"
                  v-on:click="setCountry(country)"
                >
                  <img
                    :src="country.CountryFlag"
                    class="flag-class"
                    height="60px"
                    width="100px"
                  />
                  <h6 class="pt-3">{{ country.CountryName }}</h6>
                </div>
              </div>
            </div>
          </b-modal>

          <!-- RESET PASSWORD -->
          <div class="welcome-b">
            <!-- Modal Component -->
            <b-modal
              ref="enterPassword"
              id="enterPassword"
              title="Enter Your Password"
              hide-footer
            >
              <div class="row mx-4 my-4">
                <div class="col-md-12 loginmodal">
                  <div class="mob-login-box">
                    <div class="text-danger my-2 small font-weight-bold">
                      {{ errorMessage.error }}
                    </div>
                    <b-form
                      @submit.prevent="validateBeforeSubmit('verifyPassword')"
                      data-vv-scope="verifyPassword"
                    >
                      <b-input
                        type="password"
                        v-model="userDetails.password"
                        class="mb-2 mt-1 mx-auto pc-input"
                        id="password1"
                        name="password1"
                        placeholder="Enter Your Password"
                      />
                      <div class="mt-3">
                        <input
                          type="submit"
                          class="btn btn-danger gogo-btn"
                          value="Confirm"
                        />
                      </div>
                    </b-form>
                  </div>
                </div>
              </div>
            </b-modal>
          </div>
          <!-- RESET PASSWORD ENDS -->

          <!-- ERROR POPUP -->
          <div class="welcome-b">
            <!-- Modal Component -->
            <b-modal
              ref="errorModal"
              id="errorModal"
              title="Something went wrong!"
            >
              <div class="row mx-4 my-4">
                <div class="col-md-12 loginmodal">
                  <div class="mob-login-box">
                    <div class="text-danger my-2 small font-weight-bold">
                      {{ errorMessage.updateProfile }}
                    </div>
                  </div>
                </div>
              </div>
            </b-modal>
          </div>
          <!-- ERROR POPUP ENDS -->

          <!-- <div class="mb-3 mb-md-4">
            <input v-validate="'required'" v-model="userDetails.Password" type="password" id="editPassword" :disabled="isPasswordDisbaled">
            <label for="editPassword" class="mb-0 ml-2 text-nowrap"><span v-on:click="isPasswordDisbaled= !isPasswordDisbaled"
                class="text-primary">Change</span> your Password</label>
          </div>-->
          <div>
            <div class="text-success small font-weight-bold pb-2">
              {{ errorMessage.updateProfile }}
            </div>
            <input
              class="btn-gogo"
              @click="validateBeforeSubmit('updateProfile')"
              value="Save Changes"
            />
          </div>
        </div>
      </form>
    </div>

    <!-- <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 d-flex align-items-center mb-5">
      <form>
        <b-form-checkbox class="mb-2"> I would like to receive promotional newsletters, updates and news regarding upcoming movies
          and special screenings.</b-form-checkbox>

        <b-form-checkbox>I would like to receive SMS’s and WhatsApp messages via official GoGo Cinema channels to keep
          me updated. </b-form-checkbox>


      </form>
    </div>-->
  </div>
</template>

<script>
import { makeRequest } from "@/helper/internet.js";
import { TokenService, CountryService } from "@/services/storage.service";
import { URL_BASE } from "@/helper/constants.js";
import EventBus from "@/eventBus.js";
import MainServices from "@/services/mainService.js";
import AuthServices from "@/services/AuthServices.js";
import debounce from "debounce";
import axios from "axios";

export default {
  data() {
    return {
      fbSignInParams: {
        scope: "email",
        return_scopes: false
      },
      googleSignInParams: {
        client_id:
          "911938447926-kls328d23otm80v12n1jq13h8ajeh57f.apps.googleusercontent.com"
      },
      countries: [],
      CountryCodeList: [],
      countriesCopy: [],
      userDetails: {
        UserName: "",
        Email: "",
        MobileNo: "",
        ProfileURl: ""
      },
      errorMessage: {
        updateProfile: "",
        error: ""
      },
      countryDetails: {},
      isEmailDisabled: true,
      isPhoneNumberDisabled: true,
      isPasswordDisbaled: true,
      isUserNameDisabled: true,
      searchCode: ""
    };
  },
  computed: {
    getCountries() {
      return this.$store.getters.getCountries;
    }
  },
  mounted() {
    this.getAllGetCountryList();
    EventBus.$emit("CHECKROUTE", true);
    EventBus.$on("onProfileSuccess", () => {
      this.updateUserProfile();
    });
    EventBus.$emit("FOOTERSET", true);
    EventBus.$emit("BOTTOMTABCHANGE", "4");
  },
  beforeMount() {
    this.fetchUserDetails();
    this.countryDetails = CountryService.getCountry();
  },
  beforeDestroy() {
    EventBus.$emit("FOOTERSET", false);
    EventBus.$emit("CHECKROUTE", false);
  },
  methods: {
    getAllGetCountryList: function() {
      MainServices.GetCountries()
        .then(response => {
          const { data } = response;
          if (data.data.length > 0) {
            this.CountryCodeList = data.data;
            this.countries = data.data;
            this.countriesCopy = data.data;
          }
        })
        .catch(err => {
          console.log("error:", err);
        });
    },
    onSearchCode() {
      if (this.searchCode && this.searchCode.length > 0) {
        this.CountryCodeList = this.countriesCopy.filter(x => {
          if (
            x.country_mob_code &&
            x.country_mob_code
              .toLowerCase()
              .includes(this.searchCode.toLowerCase())
          ) {
            return x;
          } else if (
            x.country_name &&
            x.country_name.toLowerCase().includes(this.searchCode.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.CountryCodeList = this.countriesCopy;
      }
    },
    _getAllGetCountryList: function() {
      makeRequest("/AllGetCountryList/", "POST", null, {})
        .then(response => {
          const { error, res } = response;
          if (res.data.Status) {
            this.CountryCodeList = res.data.Country;
          }
        })
        .catch(error => {
          console.log("Error", error);
          //   resolve(null);
        });
    },

    onChangeCountryCode(country) {
      this.userDetails.CountryCode = country.country_mob_code;
      this.userDetails.country_mob_code = country.country_mob_code;
      this.$forceUpdate();
    },
    onChangeCountry: function() {
      console.log("sdhsbdub");
      makeRequest("/GetCountryList/", "POST", null, {})
        .then(response => {
          const { error, res } = response;
          if (!error && res.data.Status) {
            this.$refs.countryModalRef.show();
            this.countries = res.data.Country;
          }
        })
        .catch(error => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    setCountry: function(country) {
      CountryService.saveCountry(country);
      window.location.reload();
    },
    fetchUserDetails: function() {
      let user = JSON.parse(window.localStorage.getItem("user")) || {};
      console.log("USER fetchUserDetails", user);
      if (user) {
        this.userDetails.Email = user.cust_email;
        this.userDetails.phone_no = user.cust_mobile;
        this.userDetails.country_mob_code =
          user.country_mob_code || user.country_code;
        this.userDetails.UserName = user.first_name;
        this.userDetails.MobileNo = user.cust_mobile;
      }
      this.$forceUpdate();
      // makeRequest("/Account/GetUserProfile", "POST", token, null)
      //   .then(result => {
      //     if (!result.error && result.res && result.res.data) {
      //       this.userDetails = result.res.data;
      //       this.userDetails.MobileNo = this.userDetails.MobileNo.trim().replace(
      //         /" "/g,
      //         ""
      //       );
      //     } else {
      //       TokenService.removeToken();
      //       window.location.pathname = "/";
      //     }
      //   })
      //   .catch(error => {
      //     TokenService.removeToken();
      //     window.location.pathname = "/";

      //     console.log("Error", error);
      //   });
    },

    onFileChanged: function(event) {
      let token = TokenService.getToken();
      this.testImageData = event.target.files[0];
      let payload = {
        UserName: this.userDetails.email,
        Email: this.userDetails.Email,
        MobileNo: this.userDetails.MobileNo,
        UserName: this.userDetails.UserName
      };
      payload = JSON.stringify(payload);
      let formData = new FormData();
      formData.append("profilepic", this.testImageData);
      formData.append("access_token", token);
      formData.append("data", payload);
      axios
        .post(`${URL_BASE}` + "/Account/UpdateProfile", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(res => {
          if (res && res.data.Status) {
            this.userDetails.ProfileURl = res.data.UpdatePic1;
          } else {
            this.$refs.errorModal.show();
            this.errorMessage.updateProfile = res.data.Message;
          }
        })
        .catch(error => {
          this.$refs.errorModal.show();
          this.errorMessage.updateProfile = "Something went wrong";
        });
    },

    validateBeforeSubmit(scope) {
      if (scope == "updateProfile") {
        this.$validator.validateAll(scope).then(result => {
          console.log("RESULR validateAll", result);
          if (result) {
            console.log("i am here");
            // this.$refs.enterPassword.show();
            this.updateUserProfile();
          } else {
            this.errorMessage.updateProfile = "Something went wrong";
          }
          return;
        });
      }
      if (scope == "verifyPassword") {
        this.$validator.validateAll(scope).then(result => {
          if (result) {
            let payload = {
              UserName: this.userDetails.Email,
              Password: this.userDetails.password
            };
            makeRequest("/Account/login", "POST", null, payload)
              .then(response => {
                const { error, res } = response;
                if (!error && res.data.Status) {
                  TokenService.saveToken(res.data.access_token);
                  this.updateUserProfile();
                } else {
                  this.errorMessage.error = res.data.Message;
                }
              })
              .catch(error => {
                console.log("Error", error);
              });
          }
          return;
        });
      }
    },
    //google
    onGoogleSignInSuccess(googleUser) {
      EventBus.$emit("OnGoogleSignIn", googleUser);
    },
    onGoogleSignInError(error) {
      this.errorMessage.error = error;
      setTimeout(() => {
        this.errorMessage.error = "";
      }, 5000);
    },
    //fb
    onSignFBInSuccess(response) {
      EventBus.$emit("OnFacebookSignIn", response);
    },

    onSignFBInError(error) {
      this.errorMessage.error = error;
      setTimeout(() => {
        this.errorMessage.error = "";
      }, 5000);
    },
    updateUserProfile() {
      this.showLoading();
      let payload = {
        email: this.userDetails.Email,
        phone_no: this.userDetails.MobileNo,
        first_name: this.userDetails.UserName,
        country_mob_code: this.userDetails.country_mob_code
      };
      AuthServices.UpdateUser(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            localStorage.removeItem("user");
            localStorage.setItem("user", JSON.stringify(data.Records[0]));
            this.errorMessage.updateProfile = data.message;
            this.fetchUserDetails();
            EventBus.$emit("profileUpdate");
          } else {
            this.errorMessage.updateProfile = data.message;
          }
        })
        .catch(err => {
          console.log("Error:", err);
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    _updateUserProfile() {
      let token = TokenService.getToken();
      let payload = {
        Email: this.userDetails.Email,
        MobileNo: this.userDetails.MobileNo,
        UserName: this.userDetails.UserName,
        CountryCode: this.userDetails.CountryCode
      };
      makeRequest("/Account/UpdateProfile", "POST", token, payload)
        .then(response => {
          const { error, res } = response;
          if (!error && res.data.Status) {
            this.$refs.enterPassword.hide();
            this.errorMessage.updateProfile = res.data.Message;
          } else {
            this.errorMessage.error = res.data.Message;
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    }
  }
};
</script>

<style>
.border-md-right {
  border-right: 1px solid #495057b8;
}

.flag-class {
  border-style: solid;
  border-width: 1px;
}

@media (max-width: 1024px) {
  .border-md-right {
    border-right: none;
  }
  .edit-profile-link {
    display: block !important;
  }
}

.profile-img {
  position: relative;
  display: table;
  overflow: hidden;
  border-radius: 50%;
}
.profile-img > img {
  border-radius: 50%;
  height: 90px;
  width: 90px;
  object-fit: cover;
}
.change-class {
  font-style: italic;
}

.dropdown-toggle {
  color: #495057;
}
.aaaa button {
  color: #212529;
}
.profile-img:hover .edit-profile-link {
  display: block;
}

.edit-profile-link {
  position: absolute;
  display: none;
  bottom: 0;
  width: 100%;
  text-align: center;
  padding-bottom: 10px;
  background: #f2f2f2;
  opacity: 0.9;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/myaccount.vue